import { render, staticRenderFns } from "./ZArrow.vue?vue&type=template&id=20e5e936&scoped=true&"
import script from "./ZArrow.vue?vue&type=script&lang=js&"
export * from "./ZArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e5e936",
  null
  
)

export default component.exports